module.exports = __webpack_public_path__ + "static/media/indexHeader.11273ceb.png";